import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";

export const profilePictureAPI = createApi({
  reducerPath: "profilePictureAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = Cookies.get('authToken');
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    apiprofilepicture: builder.mutation({
      query: (payload) => ({
        url: `/user/profile-picture/upload`,
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const { useApiprofilepictureMutation } = profilePictureAPI;